import React from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { RenderTextField as TextField } from '../../components/RenderTextField';
import { validateTrackingCategoriesEditForm } from './validateTrackingCategoriesEditForm';
import LeavePrompt from '../../components/LeavePrompt';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';

const validate = values => {
  const requiredFields = ['categoryDescription.name', 'categoryDescription.description'];

  return validateTrackingCategoriesEditForm(values, requiredFields);
};

const styles = theme => ({
  stepContainer: {
    display: 'flex',
    paddingRight: '20px',
  },
  stepChildren: {
    margin: '10px 0 156px 10px',
    maxWidth: '974px',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      marginTop: '54px'
    },
    [theme.breakpoints.up('lg')]: {
      marginLeft: '64px'
    },
  },
  languagesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '30vw',
    maxWidth: '370px',
    minWidth: '130px',
    borderRight: '2px solid rgba(178,178,178,0.5)',
    marginLeft: -25
  },
  languagesListTitle: {
    fontWeight: '500',
    margin: '18px 0 14px 35px',
  },
  language: {
    padding: '19px 0 19px 35px',
  },
  languageSelected: {
    backgroundColor: 'rgba(237,237,237,0.5)',
    '&& span': {
      color: '#00A1A1 !important',
    },
  },
  languageText: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
    '&& > p': {
      padding: '3px 12px',
      backgroundColor: '#EDEDED',
      borderRadius: '14px',
      color: 'rgba(33,35,34,0.5)',
      marginLeft: '14px',
      fontSize: '13px',
    },
    '&& > span': {
      fontSize: '14px',
      color: '#212322',
      fontWeight: 400,
    },
  },
  subtitle: {
    marginTop: '5px',
  },
  button: {
    marginLeft: '10px',
  },
  cancelButton: {
    backgroundColor: '#EDEDED',
    color: '#212322',
    '&&:hover': {
      backgroundColor: '#EDEDED',
    }
  },
  previewButton: {
    backgroundColor: '#00A1A1',
    color: '#FFFFFF',
    '&&:hover': {
      backgroundColor: '#00A1A1',
    }
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    }
  },
  titleWrapper: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
    '&& > h2': {
      fontWeight: 400
    }
  },
});

class Form extends React.Component {
  constructor (props) {
    super(props);
  }

  render() {
    const { classes, record, onSubmit, languages, onLanguageChange, chosenLanguage } = this.props;
    const encodedURI = encodeURIComponent(record.website);
    const backURL = `/websites/${encodedURI}/cookie_settings`;
    return (
      <div>
        <div className={classes.stepContainer}>
          <div className={classes.languagesWrapper}>
            <Typography className={classes.languagesListTitle} variant='subtitle1'>
              Available languages:
            </Typography>
            <List component='nav'>
              {(languages || []).map((language) => (
                <ListItem
                  button
                  key={language.id}
                  onClick={() => chosenLanguage !== language.id && onLanguageChange(language)}
                  className={`${classes.language} ${
                    chosenLanguage === language.id ? classes.languageSelected : null
                  }`}
                >
                  <ListItemText
                    primary={language.name}
                    secondary={language.originId}
                    className={classes.languageText}
                  />
                </ListItem>
              ))}
            </List>
          </div>
          <div className={classes.stepChildren}>
            <div className={classes.container}>
              <LeavePrompt
                dirty={this.props.dirty && !this.props.submitting}
                message='You have unsaved data. Do you want to leave anyway?'
              />
              <FinalForm
                onSubmit={onSubmit}
                validate={validate}
                initialValues={this.props.initialValues}
                render={({ handleSubmit, pristine, invalid }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3} alignItems='flex-start'>
                      <Grid item xs={12} sm={5} lg={4} className={classes.titleWrapper}>
                        <Typography variant='h6'>Consent Category</Typography>
                        <Typography className={classes.subtitle} variant='body2'>
                          Customize the category to better fit your data collection purpose
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={7} lg={8} className={classes.buttons}>
                        <Button
                          className={`${classes.button} ${classes.cancelButton}`}
                          component={Link}
                          data-testid="cookie-category-back-button"
                          to={backURL}
                        >
                          GO BACK
                        </Button>
                        <Button
                          className={`${classes.button} ${classes.cancelButton}`}
                          data-testid="cookie-category-cancel-button"
                          component={Link}
                          to={backURL}
                        >
                          CANCEL
                        </Button>
                        <Button
                          color='secondary'
                          variant='contained'
                          className={`${classes.button} consent-edit-saveandpublish-button`}
                          type='submit'
                          data-testid="cookie-category-save-publish-button"
                          disabled={pristine || invalid}
                        >
                          Save & publish
                        </Button>
                      </Grid>
                    </Grid>
                    <div className={classes.wrapper}>
                      <Grid container spacing={3}>
                        <Grid item xs={6}>
                          <Field
                            component={TextField}
                            className={classes.input}
                            name='categoryDescription.name'
                            label='Category Name'
                            data-testid="category-name-edit-input"
                            margin='normal'
                            required
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <Field
                            component={TextField}
                            className={classes.input}
                            name='label'
                            label='Category SDK'
                            margin='normal'
                            required
                            fullWidth
                            disabled={true}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Field
                            component={TextField}
                            className={classes.input}
                            name='categoryDescription.description'
                            label='Category Description'
                            data-testid="category-description-edit-input"
                            margin='normal'
                            required
                            fullWidth
                            multiline
                            maxRows={10}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </form>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const StyledForm = withStyles(styles)(Form);
export default StyledForm;
